import React, { createContext, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import dbService from '../services/dbService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem('user')));

  const login = async (email, password) => {
    const allUsers = await dbService.getAll('users');
    const foundUser = allUsers.find(u => u.email === email && u.password === password);

    if (foundUser && foundUser.status === 'Active') {
      localStorage.setItem('user', JSON.stringify(foundUser));
      setUser(foundUser);
      navigate('/dashboard');
      return { success: true, message: '' };
    }
    if (foundUser && foundUser.status !== 'Active') {
        return { success: false, message: 'User account is inactive.' };
    }
    return { success: false, message: 'Invalid email or password.' };
  };

  const logout = () => {
    localStorage.removeItem('user');
    setUser(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);